/*
2023.09.13
マーキーのテキストを初期でブロック内に入る分は表示、1秒後に流れていくように変更
*/
var marqueeTimer;
var marquee = {
	target: "",
	duration: 3000,
	textW: 0,
	wrapW: 0,
	textWidth: 0,
	needSlide: false,
	isInit: false,
	init: function(idx){
		//console.log( $(".marquee p a").text() )
		marquee.textWidth = Math.floor( marquee.getTextWidth()*1.07 );
		if(isSP){ return false}
		$(".marquee").attr("data-gap",$(".marquee").width() );
		if( marquee.textWidth > $(".marquee").width() ){
			$(".marquee").marquee('destroy');
			$('.marquee').marquee({
				//time in milliseconds before the marquee will start animating
				delayBeforeStart: 2000,
				//'left' or 'right'
				direction: 'left',
				gap: 50,
				//true or false - should the marquee be duplicated to show an effect of continues flow
				duplicated: true,
				startVisible: true
			});
		}
		if(!marquee.isInit){
			marquee.isInit = true;

		}
		/*
		let blockW = $(".wrap_marquee").width();
		
		console.log(marquee.textWidth, blockW)
		if(marquee.textWidth > blockW){
			marquee.needSlide = true;
		}else{
			marquee.needSlide = false;
		}
		$("#now_on_air").removeClass("change");
		$(".marquee_inner").removeClass("disable");
		clearInterval(marqueeTimer);
		setTimeout(function(){
			if(winSize === 0 || winSize === 1){ return false;}

			if(marquee.needSlide){
				marquee.move();
			}
		}, marquee.duration);
		$(window).on("focus", function(){
			if( $(".marquee_inner").hasClass("disable") ){
				$(".marquee_inner").removeClass("disable");
			}
		})
		*/
	},
	reset: function(){
		clearInterval(marqueeTimer);
		$(".marquee_inner").removeClass("notransition");
		$(".marquee_inner").addClass("disable");
		$(".marquee p").css({
			"transform": ""
		});
	},
	getTextWidth: function(){
		var txt = $(".marquee p").text();
		var w 	= $("#ruler").text(txt).get(0).offsetWidth;
		return w;
	},
	move: function(){
		let _x = 0;
		let diff 		= marquee.textWidth + $(".wrap_marquee").width();
		let $marqueeP 	= $(".marquee"),
			$marqueeText = $(".marquee p");
		clearInterval(marqueeTimer);
		marqueeTimer = setInterval(function(){
			_x -= 1;
			if(_x < -diff){
				clearInterval(marqueeTimer);
				
				$(".marquee_inner").addClass("notransition");
				setTimeout(function(){
					$(".marquee_inner").addClass("disable");
					$marqueeText.css({
						"transform": ""
					});
					setTimeout(function(){
						$(".marquee_inner").removeClass("notransition");
						$(".marquee_inner").removeClass("disable");
					},33);
				},100);
				
			}else{
				$marqueeText.css({
					"transform": "translate3d(" + _x + "px, 0, 0)"
				});
			}
		}, 22);
	}
}